import { ProductTicketStatus } from "@simplyk/common";

import { CommandFromQuery } from "../types";

type TicketCancellationStatus = {
  allTicketsCanceled: boolean;
  someTicketsCanceled: boolean;
};

export const getTicketCancellationStatus = (
  productTickets: CommandFromQuery["productTickets"] | undefined
): TicketCancellationStatus => {
  if (!productTickets || productTickets.length === 0) {
    return { allTicketsCanceled: false, someTicketsCanceled: false };
  }

  const canceledCount = productTickets.filter((ticket) => ticket.status === ProductTicketStatus.Canceled).length;

  return {
    allTicketsCanceled: canceledCount === productTickets.length,
    someTicketsCanceled: canceledCount > 0 && canceledCount < productTickets.length,
  };
};
